// V2 前端共享：换算函数（同源 SlideCanvas）+ 皮肤类型 + kicker/foot 文案
import { px, pt, box } from "../SlideCanvas";
import type { V2Skin } from "../../lib/v2geo.generated";
import { LAYOUT_V2_LABEL } from "../../lib/tokens.generated";

export { px, pt, box };
export type { V2Skin };

export function kickerOf(page: number, layout: string): string {
  const label = (LAYOUT_V2_LABEL as Record<string, string>)[layout] ?? layout;
  return `${String(page).padStart(2, "0")} · ${label}`;
}

export function footOf(deckTitle?: string): string {
  return deckTitle ? `策略咖 · ${deckTitle} | MARKETING PLAN` : "策略咖 | MARKETING PLAN";
}

/** 标题长度分档（对应后端 cover.ts titleSize） */
export function titleSize(title: string, full: number): number {
  const len = [...title].length;
  if (len <= 8) return full;
  if (len <= 12) return Math.round(full * 0.78);
  return Math.round(full * 0.62);
}
